'use strict';
/**
 *
 * @param win
 * @returns {{local: *, session: *}}
 */

function init(win) {
  if (win === void 0) {
    win = {};
  }

  function Storage() {} // Missing definitions for length and key


  Storage.prototype = {
    getItem: function getItem(key) {
      return key in this ? this[key] : null;
    },
    setItem: function setItem(key, value) {
      this[key] = "" + value;
    },
    removeItem: function removeItem(key) {
      delete this[key];
    },
    clear: function clear() {
      for (var p in this) {
        if (this.hasOwnProperty(p)) {
          delete this[p];
        }
      }
    }
  };

  function canUse(name) {
    var unique = "testStorage" + Date.now();

    try {
      var storage = win[name];
      storage.setItem(unique, unique);
      var value = storage.getItem(unique);
      storage.removeItem(unique);

      if (value !== unique) {
        throw 'not equal'; //eslint-disable-line no-throw-literal
      }
    } catch (e) {
      return false;
    }

    return true;
  }

  return {
    local: canUse('localStorage') ? win.localStorage : new Storage(),
    session: canUse('sessionStorage') ? win.sessionStorage : new Storage()
  };
}

module.exports = init;
//# sourceMappingURL=storage.js.map